import React from "react";

export default function AttendanceGlassCard({
    allowOverflow,
    children,
    className,
    hideGradient,
    noHover,
    ...props
}) {
    return (
        <div
            {...props}
            className={`relative ${allowOverflow ? "overflow-visible" : "overflow-hidden"} bg-white/90 backdrop-blur-2xl border border-white/50 shadow-[0_8px_30px_rgba(0,0,0,0.04)] rounded-[2rem] transition-all duration-300 ease-out ${!noHover && "hover:shadow-2xl hover:-translate-y-1 cursor-pointer"} ${className}`}
        >
            {!hideGradient && <div className="absolute inset-0 bg-gradient-to-br from-white/80 via-transparent to-transparent pointer-events-none rounded-[2rem]"></div>}
            <div className="relative z-10 h-full">{children}</div>
        </div>
    );
}
